import { pickThemeFontStyles } from '@/theme';
import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';

export const StyledMessageModal = styled(AntdModal)`
  .ant-modal-title {
    text-align: center;
    ${pickThemeFontStyles('20', '24', 'BOLD')};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  margin-block: 1.5rem;
  ${pickThemeFontStyles('16', '20')};
`;

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;
